import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { array, func } from 'prop-types';
import FlowPostbackStatus from './FlowPostbackStatus';
import CustomControl from '../CustomControl/CustomControl';
import Hint from '../Hint/Hint';
import { FHTMLMessage, FMessage } from '../../hoc/IntlComponents';

const GENERATE_CONVERSION_STATUS = 2;

class FlowPostbackStatuses extends PureComponent {
  static propTypes = {
    statuses: array.isRequired,
    selected: array.isRequired,
    onStatusChange: func.isRequired,
  };

  static defaultProps = {
    statuses: [],
    selected: [GENERATE_CONVERSION_STATUS],
    onStatusChange() {},
  };

  state = {
    enabled: true,
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState(() => ({
      enabled: nextProps.selected.length !== 0,
    }));
  }

  toggleExtraStatuses = () => {
    this.setState(
      (prevState) => ({
        enabled: !prevState.enabled,
      }),
      () => {
        if (!this.state.enabled) {
          this.props.onStatusChange([]);
        } else {
          this.selectAllStatuses();
        }
      },
    );
  };

  handleChange = ({ target }) => {
    const id = parseInt(target.value, 10);
    const { selected } = this.props;
    if (selected.includes(id)) {
      this.props.onStatusChange(selected.filter((status) => status !== id));
    } else {
      this.props.onStatusChange([...selected, id]);
      this.setState(() => ({ enabled: true }));
    }
  };

  selectAllStatuses = () =>
    this.props.onStatusChange(this.props.statuses.map((status) => status.id));

  render() {
    const { statuses, selected } = this.props;
    const { enabled } = this.state;

    return (
      <div className="postback-statuses">
        <span className="postback_status_all_wrapper">
          <CustomControl
            id="postback_status_all"
            className="custom-control-xs"
            value="all"
            checked={enabled}
            onChange={this.toggleExtraStatuses}
          >
            <FormattedMessage
              id="flow.form.postback.report-statuses"
              defaultMessage="Report statuses"
            />
          </CustomControl>
          <span
            onClick={(e) => {
              e.preventDefault();
            }}
          >
            <Hint
              id="postback_status_all_hint"
              // title={<FMessage id="flow.form.postback.report-statuses.hint.header" />}
              text={<FHTMLMessage id="flow.form.postback.report-statuses.hint.body" />}
            />
          </span>
        </span>

        <ul className="flow-postback-statuses">
          {statuses.map(({ id, title }) => (
            <FlowPostbackStatus
              key={id}
              onChange={this.handleChange}
              label={title}
              status={id}
              checked={selected.includes(id)}
            />
          ))}
        </ul>
      </div>
    );
  }
}

export default FlowPostbackStatuses;
